import type { Stripe, StripeElementStyle } from "@stripe/stripe-js";

import { loadStripe } from "@stripe/stripe-js";

import { env } from "@/config/env";

let stripePromise: null | Promise<null | Stripe> = null;

export function isStripeConfigured(): boolean {
  return env.VITE_STRIPE_PUBLISHABLE_KEY.startsWith("pk_");
}

export function getStripe(): null | Promise<null | Stripe> {
  if (!isStripeConfigured()) return null;

  stripePromise ??= loadStripe(env.VITE_STRIPE_PUBLISHABLE_KEY);

  return stripePromise;
}

export function getStripeElementStyle(): StripeElementStyle {
  const rootStyle = getComputedStyle(document.documentElement);
  const token = (name: string) =>
    `rgb(${rootStyle.getPropertyValue(name).trim()})`;

  return {
    base: {
      "::placeholder": { color: token("--text-placeholder") },
      color: token("--text-primary"),
      fontFamily: getComputedStyle(document.body).fontFamily,
      fontSize: "16px",
      lineHeight: "24px",
    },
    invalid: { color: token("--text-primary") },
  };
}
